
export default function ProjsOutlet(){
  return(
    <>
      Projects Landing Page coming soon!
    </>
  );
}